// Global styles
@import '~@s-ui/theme/lib/index';

// Motor global styles
@import '~@adv-mt/mt-theme/lib/motor';

// Global components styles
@import '~@s-ui/react-atom-button/lib/index';

// Motor components styles
@import '~@adv-mt/mt-layout-basic/lib/index';

@import '~@adv-mt/mt-form-dealer-rating/lib/index';

@import '~@s-ui/react-molecule-notification/lib/index';

@import '~@adv-mt/mt-svg-icons/lib/index';

@import '~@s-ui/react-atom-toast/lib/index.scss';

$w-mt-form-notification: 300px;

.mt-Rating {
  // overriding sui style as per UX requirements
  .sui-MoleculeStepper--design-compressed {
    overflow: visible;
  }

  &-emptyState {
    display: flex;
    flex-direction: column;
    gap: $g-l;
    justify-content: space-between;

    @include media-breakpoint-up(m) {
      flex-direction: row;
    }

    &Content {
      display: flex;
      flex-direction: column;
      flex: 1;
      gap: $g-xl;

      &Button {
        width: 100%;

        @include media-breakpoint-up(m) {
          width: 20%;
        }
      }

      &ImageMobile {
        display: flex;

        @include media-breakpoint-up(m) {
          display: none;
        }
      }

      &Title {
        font-size: $fz-xl;
      }

      &Description {
        font-size: $fz-l;
      }
    }

    &Image {
      display: none;

      @include media-breakpoint-up(m) {
        display: flex;
      }
    }
  }

  &-notification {
    background-color: $c-error;
    color: $c-white;
    display: flex;
    align-items: center;
    gap: $g-m;
    padding: $p-s;
    width: $w-mt-form-notification;

    &Text {
      margin: 0;
    }
  }
}
